import {useEffect, useState} from "react";

const useOnResize = () =>{
    const [getWidth, setWidth] = useState (document.body.clientWidth)
    useEffect(()=>{
        const onChangeWidth = () => {
            let curPos = document.body.clientWidth;
            setWidth(curPos <= 0 ? 0: curPos)
        }
        window.addEventListener("resize", onChangeWidth, (e) => {
            e.preventDefault()
        }, {passive:true})
        return () => window.removeEventListener("resize", onChangeWidth);
    }, [getWidth])
    return getWidth
}

const useOnScroll = () => {
    const [scrollTop, setScrollTop] = useState(0);
    //   Credit: https://stackoverflow.com/questions/57453141/using-react-hooks-to-update-w-scroll
    useEffect(() => {
        function onScroll() {
            //get current height
            let currentPosition = window.pageYOffset;
            setScrollTop(currentPosition <= 0 ? 0 : currentPosition);
        }
        //by adding the event listener, we are allow to update on each scrol
        window.addEventListener("scroll", onScroll, (e) => {
            e.preventDefault();
        }, {passive:true});
        return () => window.removeEventListener("scroll", onScroll);
    }, [scrollTop]);

    return scrollTop;
}

const otherResourcesLinks = [
    {link: 'https://www.cfsph.iastate.edu/biosecurity-resource/agritourism/', title: 'CFSPH Agritourism Biosecurity Tip Sheet'},
    {link: 'https://www.ucanr.edu/sites/agritourism/', title: 'California Agritourism Website'},
    {link: 'https://www.calagtour.org', title: 'California Agricultural Tourism Directory'},
    {link: 'https://www.ucanr.edu/sites/agritourism/News_-_Events/', title: 'California Agritourism News E-newsletter'},
]


export {useOnResize, useOnScroll, otherResourcesLinks};